import axios from "../interceptors/axios";

export const registerUser = async (dataUser) => {
  try {
    const response = await axios.post("/api/register", dataUser);
    return response;
  } catch (error) {
    throw error.response.data;
  }
};

export const uploadImageProfile = async (imageProfile) => {
  try {
    const auth = JSON.parse(localStorage.getItem("auth"));
    const accessToken = auth?.access_token;

    if (!accessToken) {
      throw new Error("Token de autenticação não encontrado");
    }
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.id;

    if (!userId) {
      throw new Error("ID do usuário não encontrado");
    }
    const formData = new FormData();
    formData.append("image", imageProfile);
    const response = await axios.post(`/api/profile/image`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao enviar a imagem:", error);
    throw error.response?.data || error.message;
  }
};

export const updateProfile = async (dataUser) => {
  try {
    const auth = JSON.parse(localStorage.getItem("auth"));
    const accessToken = auth?.access_token;

    if (!accessToken) {
      throw new Error("Token de autenticação não encontrado");
    }

    const response = await axios.put(`/api/profile`, dataUser, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Erro na requisição:", error.response.data);
      return error.response;
    } else {
      console.error("Erro:", error.message);
    }
  }
};

export function formatDateToISO(dateString) {
  const [day, month, year] = dateString.split("/");
  return `${year}-${month}-${day}`;
}

export const findInfoUser = async () => {
  try {
    const auth = JSON.parse(localStorage.getItem("auth"));
    const accessToken = auth?.access_token;

    if (!accessToken) {
      throw new Error("Token de autenticação não encontrado");
    }
    const response = await axios.get(`/api/profile`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const resetPassword = async (newPasword) => {
  try {
    const auth = JSON.parse(localStorage.getItem("auth"));
    const accessToken = auth?.access_token;

    if (!accessToken) {
      throw new Error("Token de autenticação não encontrado");
    }


    const response = await axios.put(`/api/password`, newPasword, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getFavoriteProjects = async () => {
  const authData = JSON.parse(localStorage.getItem("auth"));

  try {
    const response = await axios.get(`/api/projects/favorites`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authData.access_token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar projetos favoritos:", error);
    throw error.response ? error.response.data : error.message;
  }
};

//me tornar um autor
export const becomeAuthor = async () => {
  const auth = JSON.parse(localStorage.getItem("auth"));
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;
  const accessToken = auth?.access_token;
  try {
    const response = await axios.put(
      `/api/users/change/author`,
      { user_id: userId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    const updatedUser = { ...user, level: "OA Administrador" };
    localStorage.setItem("user", JSON.stringify(updatedUser));

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

//Detalhes do autor

export const detailsAuthor = async (authorId) => {
  try {
    const response = await axios.get(`/api/author/profile/${authorId}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
